import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Дякуємо за вашу оцінку!',
  text: 'Чи можемо ми щось покращити? Поділіться з нами своєю думкою.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Ваша думка...'
      }
    ],
    submit: {
      label: 'Надіслати'
    }
  }
};
